import { Dialog } from '@a-type/ui';

export const newGameTriggerHandle = Dialog.Unstyled.createHandle();
